import { TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { useDynamicFields } from './use-dynamic-fields';

export const useFormatDynamicFieldAndLabel = () => {
  const { dynamicFields } = useDynamicFields([TemplateType_Slug.BULK_MESSAGE]);
  const convertLabelToDynamicField = (text?: string) => {
    if (!text) return text;
    const splitText = text.split(/(\[[^\]]*])/);
    return dynamicFields
      .reduce((acc, { label, symbol }) => {
        const key = '[' + label + ']';
        return acc.map((item) => item.replace(key, symbol));
      }, splitText)
      .join('');
  };

  const convertDynamicFieldToLabel = (text?: string) => {
    if (!text) return text;
    const splitText = text.split(/(\{\{[^}]*}})/);
    return dynamicFields
      .reduce((acc, { label, symbol }) => {
        return acc.map((item) => item.replace(symbol, '[' + label + ']'));
      }, splitText)
      .join('');
  };

  return { convertLabelToDynamicField, convertDynamicFieldToLabel };
};
